/**
 * 시간을 상대적으로 표시하는 유틸리티 함수
 * 예: "방금 전", "3분 전", "2시간 전", "3일 전", "2023.10.07"
 */
export const formatRelativeTime = (dateString: string): string => {
  try {
    const date = new Date(dateString);
    const now = new Date();
    const diffInSeconds = Math.floor((now.getTime() - date.getTime()) / 1000);

    // 음수인 경우 (미래 시간) - 절대값 사용
    const absDiff = Math.abs(diffInSeconds);

    // 1분 미만
    if (absDiff < 60) {
      return '방금 전';
    }

    // 1시간 미만
    if (absDiff < 3600) {
      const minutes = Math.floor(absDiff / 60);
      return `${minutes}분 전`;
    }

    // 24시간 미만
    if (absDiff < 86400) {
      const hours = Math.floor(absDiff / 3600);
      return `${hours}시간 전`;
    }

    // 7일 미만
    if (absDiff < 604800) {
      const days = Math.floor(absDiff / 86400);
      return `${days}일 전`;
    }

    // 30일 미만
    if (absDiff < 2592000) {
      const weeks = Math.floor(absDiff / 604800);
      return `${weeks}주 전`;
    }

    // 1년 미만
    if (absDiff < 31536000) {
      const months = Math.floor(absDiff / 2592000);
      return `${months}개월 전`;
    }

    // 그 외 (1년 이상) - 날짜로 표시
    return date.toLocaleDateString('ko-KR', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).replace(/\. /g, '.').replace(/\.$/, '');
  } catch (error) {
    console.error('시간 포맷 오류:', error);
    return dateString;
  }
};

/**
 * 전체 날짜 시간을 표시하는 함수
 * 예: "2023년 10월 7일 오후 11:29"
 */
export const formatFullDateTime = (dateString: string): string => {
  try {
    const date = new Date(dateString);
    return date.toLocaleString('ko-KR', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  } catch (error) {
    console.error('날짜 포맷 오류:', error);
    return dateString;
  }
};

/**
 * 간단한 날짜 표시
 * 예: "10월 7일"
 */
export const formatShortDate = (dateString: string): string => {
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString('ko-KR', {
      month: 'short',
      day: 'numeric'
    });
  } catch (error) {
    console.error('날짜 포맷 오류:', error);
    return dateString;
  }
};
